/* eslint-disable no-unused-vars */
import { DeepReadonly, Ref } from 'vue';
import { Agent_WhereInput } from '@/graphql/codegen/generated/graphql';

export type AgentsFilterRef = Pick<
  Agent_WhereInput,
  | 'licenseFilter'
  | 'coresFilter'
  | 'availableCpuFilter'
  | 'statusFilter'
  | 'logLevelFilter'
  | 'enabledAsHelperFilter'
  | 'helperPermissionsFilter'
  | 'buildGroupsFilter'
  | 'osVersionFilter'
  | 'cacheSizeFilter'
  | 'quickFilter'
  | 'searchFilter'
  | 'searchByColumns'
  | 'agentsIdFilter'
  | 'usedCpuFilter'
>;

export const mapFilterModelToGQLFilter = {
  windows: {
    licensesFilter: 'licenseFilter',
    buildGroups: 'buildGroupsFilter',
    osVersionFilter: 'osVersionFilter',
    status: 'statusFilter',
    cpuView: 'availableCpuFilter',
    coreView: 'coresFilter',
    logLevel: 'logLevelFilter',
    cacheView: 'cacheSizeFilter',
    helpers: 'enabledAsHelperFilter',
    agentHelperPermissions: 'helperPermissionsFilter',
  },
  linux: {
    status: 'statusFilter',
    buildGroups: 'buildGroupsFilter',
    cpuView: 'usedCpuFilter',
    licensesFilter: 'licenseFilter',
  },
};

export type LinuxAgentFilterRef = Pick<Agent_WhereInput, 'statusFilter' | 'buildGroupsFilter' | 'usedCpuFilter' | 'licenseFilter'>;

export type AgentsFilter = {
  GQL_AgentsFilter: DeepReadonly<Ref<AgentsFilterRef>>;
  agentsLeftDrawerActiveFilters: Readonly<Ref<number>>;
  setAgentsLeftDrawerActiveFilters: (newValue: number) => void;
  setGQL_AgentsFilter: (type: keyof AgentsFilterRef) => void;
  setGQL_LinuxAgentsFilter: (type: keyof LinuxAgentFilterRef) => void;
  clearGQL_AgentsFilter: (keys?: Array<keyof AgentsFilterRef>) => void;
  setGQL_AgentsSearchFilter: (payload: any) => void;
  setGQL_AgentsQuickFilter: (payload: any) => void;
  updateFilter: (payload: any) => void;
  setEnabledCoreFilters: (payload: any) => void;
  clearFilters: () => void;
  setAgentCacheView: (payload: any) => void;
  setAgentsCoreView: (payload: any) => void;
  filter: any;
};
